<template>
  <div class="basic-block block-fortune-input" :style="styles">
    <div class="content-wrap">
      <form :action="actionMod" :method="method" ref="form">
        <input type="hidden" name="_token" :value="token">
        <form-birthday
          v-model="birthday"
          name="birthday"
          label="生年月日"
          placeholderYear="1999"
          placeholderMonth="09"
          placeholderDay="09"
          :validation="{ rules: {birthRange: true, required: true} }"
        />
        <div class="birthtime-block">
          <form-birthtime-simple
            label="出生時間"
            name="birthtime"
            v-model="birthtime"
            :is-disabled="isBirthtimeUnknown"
          />
          <base-checkbox
            name="isBirthtimeUnknown"
            class="is-birthtime-unknown"
            label="不明"
            @change="changeBirthtimeUnknown"
          />
          <transition name="alt-list">
            <div class="alternative-birthtime-base" v-if="isBirthtimeUnknown">
              <p>出生時間が分からない方は、下記の中から自分の性格に近いものを１つお選びください</p>
              <div class="alt-word-wrap">
                <span
                  class="alt-word"
                  v-for="(item, idx) in alternativeBirthtimeList"
                  :key="`bt${idx}`"
                  :class="{selected: idx === selectIdxAltBirthtime}"
                  @click="onAltWordClick(idx)"
                >{{ item.words }}</span>
              </div>
            </div>
          </transition>
        </div>
        <form-select
          name="from_pref"
          v-model="fromPref"
          label="出生地"
          :default-no-select="true"
          :options="FORM_OPTIONS.from_pref"
          :validation="{ rules: {required: true} }"
        />
        <lp-base-button :label="buttonLabel" design="fill" :color-scheme="colorScheme" class="submit-btn" :isDisabled="buttonIsDisabled" @clicked="clicked" />
      </form>
    </div>
  </div>
</template>

<script>
import { FORM_OPTIONS } from '@/CONSTS'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BaseCheckbox from '@/utvStore/components/recommend/lp/counselor/somarimone/partials/BaseCheckbox'


const ALTERNATIVE_BIRTHTIMES = [
  {time: '00:00', words: '自分磨きが大好き', timeLabel: '子午'},
  {time: '02:00', words: '趣味や価値観を大切にしている', timeLabel: '丑未'},
  {time: '04:00', words: '自分の仕事にはこだわりを持ちたい', timeLabel: '寅申'},
  {time: '06:00', words: '新しい出会いを大切にしている', timeLabel: '卯酉'},
  {time: '08:00', words: 'コスパのいいものに惹かれる', timeLabel: '辰戌'},
  {time: '10:00', words: '愛するパートナーがいることが何よりの幸せ', timeLabel: '巳亥'},
]
/*
①子午刻生まれ（0時）自分磨きが大好き
②丑未刻生まれ（2時）趣味や価値観を大切にしている
③寅申刻生まれ（4時）自分の仕事にはこだわりを持ちたい
④卯酉刻生まれ（6時）新しい出会いを大切にしている
⑤辰戌刻生まれ（8時）コスパのいいものに惹かれる
⑥巳亥刻生まれ（10時）愛するパートナーがいることが何よりの幸せ
 */

export default {
  name: 'BlockFortuneInput',
  components:{
    LpBaseButton,
    BaseCheckbox,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '無料で占う'
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    lpId: Number,
    pageLabel: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      FORM_OPTIONS,
      initialized: false,
      birthday: '',
      birthtime: '',
      fromPref: '',
      buttonIsDisabled: false,
      isBirthtimeUnknown: false,
      alternativeBirthtimeList: ALTERNATIVE_BIRTHTIMES,
      selectIdxAltBirthtime: 0,
    }
  },
  computed:{
    actionMod(){
      return this.$handoverParams(this.action)
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    validateFlags () {
      return this.$validator.flags
    },
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=> n[key].invalid)
      },
      deep: true
    },
  },
  mounted(){
    window.addEventListener('pageshow', () => {
      this.$el.querySelector('.timeInput .formControl').value = ':'
      if(!this.isBirthtimeUnknown) this.$el.querySelector('.is-birthtime-unknown input').checked = false
      this.initialized = true
    })
  },
  methods:{
    clicked(){
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.pageLabel}-free-shindan-button`,
      })
      this.$refs.form.submit()
    },
    changeBirthtimeUnknown(val){
      if(this.initialized) {
        if (val.checked && !this.birthtime) this.onAltWordClick(0)
        this.isBirthtimeUnknown = val.checked
      }
    },
    onAltWordClick(val){
      this.selectIdxAltBirthtime = val
      this.birthtime = this.alternativeBirthtimeList[val].time
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-fortune-input {
  background: #FFFBE3;
  padding: 0 20px 40px;

  .content-wrap{
    background: $col_white;
    border-radius: 10px;
    padding: 20px 20px 40px;
    .formset{
      display: flex;
      .form-input + .form-input{
        margin-left: 7px;
      }
    }
    .submit-btn{
      max-width: 270px;
      margin: 40px auto 0;
      @include mq('w580'){
        width: 72%
      }
    }
    .formGroup /deep/.calenderForm{
      border-radius: 5px !important;
      width: 171px !important;
      height: 40px !important;
      &.active{
        border-color: rgba(0, 0, 0, 0.15);
      }
      .formControl{
        min-height: 38px;
      }
    }
  }
}

.birthtime-block {
  .alternative-birthtime-base {
    p {
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: left;
      margin: 0 0 16px;
    }
    .alt-word-wrap {
      padding: 24px 16px;
      border: 1px solid #dadada;
      border-radius: 5px;
      .alt-word {
        display: flex;
        padding: 4px 0 0 30px;
        height: 46px;
        position: relative;
        &::before,
        &::after {
          content: "";
          display: block;
          position: absolute;
          border-radius: 21px;
          top: 4px;
          left: 0;
        }
        &::before {
          border: 1px solid #dcdfe2;
          width: 21px;
          height: 21px;
        }
        &::after {
          width: 13px;
          height: 13px;
          top: 8px;
          left: 4px;
          transition: all 200ms ease-out 0s;
          background: $l_col_keycolor;
          opacity: 0;
        }
        &.selected {
          &::after {
            opacity: 1;
          }
        }
      }
    }
  }
  /deep/ {
    .formGroup {
      display: inline-block;
      margin-right: 20px;
      .timeInput {
        .formControl {
          padding: 5px 0;
        }
      }
    }
    .is-birthtime-unknown {
      display: inline-flex;
      transform: scale(1.25);
      .baseCheckBox__input:checked + .baseCheckBox__label:before {
        background-color: $l_col_keycolor;
      }
    }

  }
}

.alt-list {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    transform: translate(0, -20px);
    opacity: 0;
  }
  &-enter-to, &-leave {
    transform: translate(0, 0);
    opacity: 1;
  }
}

/deep/ .formControl {
  &:active,
  &:focus {
    border: 1px solid;
    border-color: rgba(0, 0, 0, 0.15);
  }
}

/deep/{
  .baseButton__button {
    max-width: 270px;
    min-width: unset;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/partials/BlockFortuneInput.vue